
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { SignupFormValues } from "../schemas/signupFormSchema";
import { educationLevelOptions } from "@/utils/selectOptions";

interface EducationLevelSelectorProps {
  form: UseFormReturn<SignupFormValues>;
}

export function EducationLevelSelector({ form }: EducationLevelSelectorProps) {
  return (
    <FormField
      control={form.control}
      name="educationLevel"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Education Level</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select your education level" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {educationLevelOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
